import React from "react";
import {
  Modal,
  Form,
  Button,
} from "react-bootstrap";

export default function AddOvertimeModal({
  show,
  handleClose,
}) {

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Overtime</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form>

          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Rate</Form.Label>
            <Form.Control />
          </Form.Group>

          <Button className="save-btn w-100">
            Save
          </Button>

        </Form>

      </Modal.Body>
    </Modal>
  );
}